var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"ml-3 mt-4"},[_vm._v("Your Portfolio")]),_c('div',{staticClass:"row no-gutters mr-3"},_vm._l((_vm.stockPortfolio),function(stock){return _c('stock-card',{key:stock.id,attrs:{"stock":stock}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }